import React from 'react';
import ProviderEditPage from '@/portal/routes/providers/$providerId/edit/Page.tsx';
import { LoaderFunctionArgs, ActionFunctionArgs } from 'react-router-dom';
import { loadProvider } from '@/common/api';
import { updateProvider } from '@/common/api/Providers.ts';
import { ApiError } from '@/common/types/errors';

export async function loader({ params }: LoaderFunctionArgs) {
  if (!params.providerId) {
    throw new Response('Missing provider ID', { status: 400 });
  }

  return loadProvider(params.providerId);
}

export async function action({ request, params }: ActionFunctionArgs) {
  if (!params.providerId) {
    throw new Response('Missing provider ID', { status: 400 });
  }

  const formData = await request.formData();

  try {
    const updatedProvider = await updateProvider(
      parseInt(params.providerId),
      formData
    );
    return {
      provider: updatedProvider,
      success: true,
      flash: {
        message: `${updatedProvider.firstName} ${updatedProvider.lastName} updated successfully.`,
        type: 'success',
      },
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      if (error.status === 403) {
        return {
          success: false,
          flash: {
            message: 'Permission denied.',
            type: 'danger',
          },
        };
      }
    }
    return {
      success: false,
      flash: {
        message:
          error instanceof ApiError
            ? error.message
            : 'Something went wrong. Please try again later.',
        type: 'danger',
      },
    };
  }
}

const EditRoute: React.FC = () => {
  return <ProviderEditPage />;
};

export default EditRoute;
